import throttle from 'lodash/throttle';
import Backbone from 'backbone';

import Base from 'app/views/base';
import LoaderView from 'app/views/loader';
import tmpl from 'templates/jobs_page';

const URL = 'https://api.lever.co/v0/postings/easypost?mode=json';

export const Job = Backbone.Model.extend({ });
export const JobCollection = Backbone.Collection.extend({
  model: Job,
  url: URL,
});

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize(options) {
    this.collection = new JobCollection(options.jobs || []);
    this.listenTo(this.collection, 'sync change', this.render);

    this.addSubview('jobLoader', '#jobs_loader', new LoaderView({ type: 'flat' }));
    this.render();

    this.collection.fetch();

    $(window).on('resize', this.resizeAffix.bind(this));
  },

  /* eslint func-names: 0 */
  // I don't want `this` bound, so we'll temporarily disable this rule.
  resizeAffix: throttle(function () {
    this.affix.width(this.affix.parent().innerWidth());
  }, 20),

  afterRender() {
    this.affix = this.$el.find('.affix-auto-top');

    $('body').scrollspy({ target: '.scrollnav' });

    this.affix.affix({
      offset: {
        top: this.affix.offset().top,
      },
    });

    this.affix.width(this.affix.parent().width());
  },

  context() {
    return {
      jobs: this.collection.models.map(m => m.toJSON()),
    };
  },

  remove() {
    $(window).off('resize', this.resizeAffix);
  },
});



// WEBPACK FOOTER //
// ./app/views/jobs_page.js